import TableWithDetails from "#core/components/table-with-details/TableWithDetails"
import { useRouteParam } from "#core/hooks/useRouteParam"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import JobProfileTable from "#job-profile/components/job-profile-table/JobProfileTable"
import { JobProfileDetailsContextsProvider } from "#job-profile/contexts/JobProfileDetailsContexts"
import { Box, Skeleton } from "@mui/material"
import { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { jobProfileGet } from "../services/api"
import JobProfileDetails from "./JobProfileDetails"

export default function JobProfiles() {
	// ChangeTitle("Perfil Puesto")
	const navigate = useNavigate()
	const id = useRouteParam("id")

	const params = useMemo(() => ({ table: true, all: true }), [])
	const [reload, setReload] = useState(false)
	const refresh = () => {
		setReload(!reload)
	}
	/**
	 * @type {{ data: {data:[JobProfileType]} | null }}
	 */
	const { data, error, loading } = useApi(jobProfileGet, {
		autoFetch: true,
		params,
		reload,
	})
	if (loading) return <Skeleton variant="rectangular" width={"100%"} height={"90vh"} />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box>
			<TableWithDetails
				title="Perfil Puesto"
				ruta="/perfil-puesto"
				showDetails={id}
				table={
					<JobProfileTable
						data={data?.data || []}
						onClick={(competence) => {
							navigate(`${competence?.id}`)
						}}
						reload={refresh}
					/>
				}
				details={
					<JobProfileDetailsContextsProvider profileId={id}>
						<JobProfileDetails id={id} />
					</JobProfileDetailsContextsProvider>
				}
			/>
		</Box>
	)
}
